import React, { useContext, useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from 'src/services/firebase-service';
import logging from 'src/services/logging';
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Divider,
  Grid,
} from '@mui/material';
import { CycleContext } from 'src/context/CycleContext';

const SeederTab = () => {
  const cycle = useContext(CycleContext);
  const [calling, setIsCalling] = useState<boolean>(false);
  const [matchups, setMatchups] = useState<any[]>();

  const seedMatchup = async (playoffSeriesLetter: string) => {
    try {
      logging.info(`Seeding match ${playoffSeriesLetter}...`, 'SeederTab');
      const seedMatchup = httpsCallable(functions, 'seed-matchup');
      setIsCalling(true);
      const response = await seedMatchup({ playoffSeriesLetter });
      const data = response.data as any[];
      logging.info({ data }, 'SeederTab');
      setMatchups(data);
    } catch (error) {
      logging.error(error, 'SeederTab');
    } finally {
      setIsCalling(false);
    }
  };

  const onSeedSeries = async (e: any) => {
    await seedMatchup(e.target.innerText);
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <Card>
          <CardHeader
            title='Seed Playoff Series'
            titleTypographyProps={{ flex: '1 1 100%', variant: 'h6' }}
          />
          <Divider />
          <CardContent>
            <Grid container justifyContent='space-between'>
              <Grid item>
                <Button
                  variant='outlined'
                  onClick={onSeedSeries}
                  disabled={cycle.activeRound !== 1}
                >
                  {calling ? (
                    <CircularProgress size={24} color='inherit' />
                  ) : (
                    'A'
                  )}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant='outlined'
                  onClick={onSeedSeries}
                  disabled={cycle.activeRound !== 1}
                >
                  {calling ? (
                    <CircularProgress size={24} color='inherit' />
                  ) : (
                    'B'
                  )}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant='outlined'
                  onClick={onSeedSeries}
                  disabled={cycle.activeRound !== 1}
                >
                  {calling ? (
                    <CircularProgress size={24} color='inherit' />
                  ) : (
                    'C'
                  )}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant='outlined'
                  onClick={onSeedSeries}
                  disabled={cycle.activeRound !== 1}
                >
                  {calling ? (
                    <CircularProgress size={24} color='inherit' />
                  ) : (
                    'D'
                  )}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant='outlined'
                  onClick={onSeedSeries}
                  disabled={cycle.activeRound !== 1}
                >
                  {calling ? (
                    <CircularProgress size={24} color='inherit' />
                  ) : (
                    'E'
                  )}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant='outlined'
                  onClick={onSeedSeries}
                  disabled={cycle.activeRound !== 1}
                >
                  {calling ? (
                    <CircularProgress size={24} color='inherit' />
                  ) : (
                    'F'
                  )}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant='outlined'
                  onClick={onSeedSeries}
                  disabled={cycle.activeRound !== 1}
                >
                  {calling ? (
                    <CircularProgress size={24} color='inherit' />
                  ) : (
                    'G'
                  )}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant='outlined'
                  onClick={onSeedSeries}
                  disabled={cycle.activeRound !== 1}
                >
                  {calling ? (
                    <CircularProgress size={24} color='inherit' />
                  ) : (
                    'H'
                  )}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant='outlined'
                  onClick={onSeedSeries}
                  disabled={cycle.activeRound !== 2}
                >
                  {calling ? (
                    <CircularProgress size={24} color='inherit' />
                  ) : (
                    'I'
                  )}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant='outlined'
                  onClick={onSeedSeries}
                  disabled={cycle.activeRound !== 2}
                >
                  {calling ? (
                    <CircularProgress size={24} color='inherit' />
                  ) : (
                    'J'
                  )}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant='outlined'
                  onClick={onSeedSeries}
                  disabled={cycle.activeRound !== 2}
                >
                  {calling ? (
                    <CircularProgress size={24} color='inherit' />
                  ) : (
                    'K'
                  )}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant='outlined'
                  onClick={onSeedSeries}
                  disabled={cycle.activeRound !== 2}
                >
                  {calling ? (
                    <CircularProgress size={24} color='inherit' />
                  ) : (
                    'L'
                  )}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant='outlined'
                  onClick={onSeedSeries}
                  disabled={cycle.activeRound !== 3}
                >
                  {calling ? (
                    <CircularProgress size={24} color='inherit' />
                  ) : (
                    'M'
                  )}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant='outlined'
                  onClick={onSeedSeries}
                  disabled={cycle.activeRound !== 3}
                >
                  {calling ? (
                    <CircularProgress size={24} color='inherit' />
                  ) : (
                    'N'
                  )}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant='outlined'
                  onClick={onSeedSeries}
                  disabled={cycle.activeRound !== 4}
                >
                  {calling ? (
                    <CircularProgress size={24} color='inherit' />
                  ) : (
                    'O'
                  )}
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Grid item>
          <pre>{JSON.stringify(matchups, null, 2)}</pre>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SeederTab;
